import { Organization, Language, UserStyle } from '../models';
import { HasId } from '../interfaces';

export class User implements HasId {
    public static userRoles: string[] = [ 'superAdmin', 'siteAdmin', 'ponderaAssociate', 'organizationAdmin', 'manager', 'user' ];

    public id: number;
    public thirdPartyUserID: string;
    public firstName: string;
    public lastName: string;
    public email: string;
    public userRole: string;
    public organization: Organization;
    public organizationID: number;
    public language: Language;
    public manager: User;
    public title: string;
    public userPermissions: string[];
    public userStyles: UserStyle[];
    public userReportTypes: number[];
    public isDeactivated: boolean;
    // public isCandidate: boolean;
    public isDeleted: boolean;
    public resultsArePrivate: boolean;

    // this will be a base 64 string for the users avatar
    public avatar: string;

    // this is used to maintain the global list within the 9box
    public userInBox: boolean;

    public welcomeSent: boolean;

    public needsToPassMfa: boolean;

    public static userRoleIndex(role: string) {
        return this.userRoles.indexOf(role);
    }
}

export class UserLight implements HasId {
    id: number;
    firstName: string;
    lastName: string;
    styleId: number;
    styleName: string;
    styleCore: string;
    resultsArePrivate: boolean;
    styleOveridden: boolean;
}


// WEBPACK FOOTER //
// ./src/models/User.tsx